import './App.css';
import React from "react";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Header from "./Header";
import Footer from './Footer';
import { Text } from "react-native";
import { withRouter } from "react-router-dom";
import { VALIDATE_ROUTE } from './Constant';
import { TITLE_RETRY } from './Constant';
import { MESSAGE_REDEEM_FAILED } from './Constant';

class Retry extends React.Component {
    handleClick() {
        this.props.history.push({VALIDATE_ROUTE}.VALIDATE_ROUTE + this.props.match.params.token);
    };

    componentDidMount(){
        document.title = {TITLE_RETRY}.TITLE_RETRY;
    }

    render() {
        return (
            <div className="page-container">
                <Header />
                <div className="text-center content-wrap">
                    <Container>
                        <Row className="code-row-style" style={{marginTop: '10px'}}>
                            <Text style={{fontWeight: 'bold', color: '#7f7a7a', fontSize: '20px'}}>
                                {MESSAGE_REDEEM_FAILED}
                            </Text>
                        </Row>
                        <Row className="code-row-style" style={{marginTop: '30px'}}>
                            <Button onClick={() => this.handleClick()} className="code-button-style" variant="primary" size="lg">
                                <span style={{fontWeight: 'bold', color: 'white'}}>RETRY</span>
                            </Button>
                        </Row>
                    </Container>
                </div>
                <Footer />
            </div>
        );
    }
}

export default withRouter(Retry);